var _path, _mask, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEbay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 110",
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 0,
    height: "1em",
    width: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 30 C30 10, 70 10, 70 30",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 8
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "white"
  }), /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 70,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: 600,
    fill: "black",
    textAnchor: "middle"
  }, "ebay"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 30 H80 V90 H20 Z",
    fill: "currentColor",
    stroke: "currentColor",
    mask: "url(#mask)",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbay);
export default __webpack_public_path__ + "static/media/Ebay.e55afa22c4c03aafa6c1727fa78ac23e.svg";
export { ForwardRef as ReactComponent };